var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWesperLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1208,
    height: 181.00000000000003,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#cfd1d3",
    d: "m90.34563,0a88.89,88.89 0 0 0 -29.2,5.21a89.82,89.82 0 0 0 0,170.24a88.89,88.89 0 0 0 29.2,5.21a90.33,90.33 0 1 0 0,-180.66zm0.74,162.86a89.62,89.62 0 0 0 0,-145.06a72.53,72.53 0 0 1 0,145.06z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_2",
    fill: "#010000",
    points: "1030.1955871582031,101.56001281738281 1030.1955871582031,83.1300048828125 974.4856262207031,83.1300048828125 985.6256408691406,101.56001281738281 1030.1955871582031,101.56001281738281 ",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_3",
    fill: "#010000",
    points: "1046.7055969238281,16.449996948242188 946.4555969238281,16.449996948242188 946.4555969238281,170.00001525878906 1046.7055969238281,170.00001525878906 1046.7055969238281,151.5699920654297 966.4156799316406,151.5699920654297 966.4156799316406,34.8800048828125 1046.7055969238281,34.8800048828125 1046.7055969238281,16.449996948242188 ",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#010000",
    d: "m637.98563,133.15l19.52,-4.17c2.63,18.42 19.31,26.76 35.54,26.76c19.08,0 32,-11 32,-26.76c0,-41.24 -81.38,-13.82 -81.38,-72.38c0,-26.32 21.06,-43.44 49.36,-43.44c29.17,0 48,17.55 51.76,41l-19.52,3.51c-2.64,-15.57 -14,-26.76 -32.9,-26.76c-16,0 -28.3,8.56 -28.3,23.91c0,40.8 81.38,13.38 81.38,71.95c0,28.29 -22.16,46.49 -53.08,46.49c-25.88,0.07 -50.66,-13.57 -54.38,-40.11z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#010000",
    d: "m814.58563,110.55l0,59.45l-20,0l0,-153.55l53.74,0c29.17,0 51.32,18.87 51.32,47.17c0,26.1 -20.18,46.93 -49.79,46.93l-35.27,0zm30.28,-75.45l-30.28,0l0,57l32.25,0c21.72,0 32.24,-14 32.24,-28.51c0,-14.26 -10.3,-28.49 -34.21,-28.49z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#010000",
    d: "m1165.18563,102c22.16,-4.83 35.32,-21.28 35.32,-41.67c0,-27.64 -21.28,-43.88 -48.69,-43.88l-52.83,0l0,153.54l20,0l0,-66.66l0.1,0l0,-16.69l-0.1,0l0,-51.54l29.62,0c23.24,0 31.14,13.38 31.14,25.66c0,12.72 -8.34,25.88 -30.7,25.88l-15.47,0l9.76,16.68l41,66.67l23.65,0l-42.8,-67.99z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_7",
    fill: "#010000",
    points: "575.0056457519531,101.56001281738281 575.0056457519531,83.1300048828125 519.3056335449219,83.1300048828125 530.4456481933594,101.56001281738281 575.0056457519531,101.56001281738281 ",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_8",
    fill: "#010000",
    points: "591.5156555175781,16.449996948242188 491.2656555175781,16.449996948242188 491.2656555175781,170.00001525878906 591.5156555175781,170.00001525878906 591.5156555175781,151.5699920654297 511.2256164550781,151.5699920654297 511.2256164550781,34.8800048828125 591.5156555175781,34.8800048828125 591.5156555175781,16.449996948242188 ",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_9",
    fill: "#010000",
    points: "240.44561767578125,16.089996337890625 261.3956298828125,16.089996337890625 300.9156188964844,119.13999938964844 343.6056213378906,13.169998168945312 386.0456237792969,119.24000549316406 426.8756408691406,16.089996337890625 447.8156433105469,16.089996337890625 385.9356384277344,172.03001403808594 343.5956115722656,65.75999450683594 300.9256286621094,172.09999084472656 240.44561767578125,16.089996337890625 ",
    className: "cls-2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWesperLogo);
export default __webpack_public_path__ + "static/media/wesper-logo.32845009c04e73cdb08784336b3b39bc.svg";
export { ForwardRef as ReactComponent };